// components/ManualModal.tsx
import { useEffect } from "react";
import ReactDOM from "react-dom";

interface ManualModalProps {
  open: boolean;
  setOpen: () => void;
  title?: string;
  children: React.ReactNode;
  ref?: React.Ref<HTMLInputElement>;
}

export default function Modal({
  open,
  setOpen,
  title,
  children,
  ref,
}: ManualModalProps) {
  const modalRoot =
    typeof window !== "undefined"
      ? document.getElementById("modal-root")
      : null;

  useEffect(() => {
    if (!modalRoot) {
      const div = document.createElement("div");
      div.id = "modal-root";
      document.body.appendChild(div);
    }
  }, []);

  if (!open || !modalRoot) return null;

  return ReactDOM.createPortal(
    <div
      ref={ref}
      className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/30"
    >
      <div className="bg-white p-6 rounded-xl shadow-2xl w-full sm:max-w-[90vw] max-w-md relative">
        <button
          onClick={setOpen}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
        >
          ✕
        </button>
        {title && <h3 className="text-lg font-semibold mb-4">{title}</h3>}
        {children}
      </div>
    </div>,
    modalRoot
  );
}
